<script setup>
    import { computed } from 'vue';
    import AnswerRates from '@/components/result/ai-literacy/AnswerRates.vue';
    import SubareaGuide from '@/components/result/ai-literacy/SubareaGuide.vue';
    
    const props = defineProps({
        studentData: Object
    });

    // 학교/학급 평균 정답률 (4개 영역: AI·디지털 기술, AI·디지털 활용, AI·디지털 윤리, 인간 중심 AI)
    const ourClassPercentages = computed(() => {
        if (!props.studentData) return [0, 0, 0, 0];
        
        return [
            Number(props.studentData.school_field1_rate) || 0, // AI·디지털 기술
            Number(props.studentData.school_field2_rate) || 0, // AI·디지털 활용  
            Number(props.studentData.school_field3_rate) || 0, // AI·디지털 윤리
            Number(props.studentData.school_field4_rate) || 0  // 인간 중심 AI
        ];
    });

    // 개인 정답률 (4개 영역: AI·디지털 기술, AI·디지털 활용, AI·디지털 윤리, 인간 중심 AI)
    const overallPercentages = computed(() => {
        if (!props.studentData) return [0, 0, 0, 0];
        
        return [
            Number(props.studentData.field1_rate) || 0, // AI·디지털 기술
            Number(props.studentData.field2_rate) || 0, // AI·디지털 활용
            Number(props.studentData.field3_rate) || 0, // AI·디지털 윤리  
            Number(props.studentData.field4_rate) || 0  // 인간 중심 AI
        ];
    });

    const userRole = 'student';
</script>
<template>
    <div class="report-inner">   
        <div class="card-wrap">            
            <AnswerRates                
                :our-class-percentages="ourClassPercentages"
                :overall-percentages="overallPercentages"               
                :userRole="userRole"
            />           
            <SubareaGuide :type="userRole" :studentData="studentData" />
        </div>        
    </div>
</template>

<style lang="scss" scoped>
    .area-guide table th { background-color: rgba(var(--main-ai-primary-rgb), .3);}
    .area-guide table td:nth-child(1) {width: 20%; text-align: center; font-weight: 600;}
</style>